import { render, staticRenderFns } from "./PaymentApproval.vue?vue&type=template&id=6d2d33cf&"
import script from "./PaymentApproval.vue?vue&type=script&lang=js&"
export * from "./PaymentApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports